import { renderRichText } from '@storyblok/js';

export default function ({ preText, highlightedText, afterText, _editable, _uid }) {
  return {
    module: 'SHeaderSlogan',
    component: 's-header-slogan',
    _uid,
    _editable,
    preText: renderRichText(preText),
    highlightedText: renderRichText(highlightedText),
    afterText: renderRichText(afterText)
  };
}
